import { RootState } from 'store';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { ResourceListSelectors } from 'typings/state';
import { CancelReasonState } from 'features/CancelReason/types';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): CancelReasonState => state.cancelReason,
);
export default selectors;
